// Типы статусов талонов
export const statusType = {
  0: 'Создан и находится в изначальной очереди',
  1: 'Вызван на обработку',
  2: 'В процессе обработки',
  3: 'Закрыт (талон был обработан)',
  4: 'Закрыт по неявке',
  5: 'Переведён в новую очередь',
  6: 'Ожидание решения',
  7: 'Возвращён в очередь',
  8: 'Ручная обработка диспетчером',
  9: 'Удален системой',
  10: 'Смена услуги',
  11: 'Направлен в конкретное рабочее место',
  12: 'Начато решение вопроса',
  13: 'Завершено решение вопроса.',
  69: 'Переведен в неучитываемые',
};

// Функция для получения истории талона
export const fetchTicketHistory = async (ticketId) => {
  try {
    // Преобразуем ticketId в число, если он был строкой
    const numericTicketId = parseInt(ticketId, 10);

    // Импортируем executeReport только при вызове функции, чтобы избежать циклических зависимостей
    // eslint-disable-next-line global-require
    const { executeReport, REPORT_TYPES } = require('../../../../../../../../logic/utils/reportRequest');

    // Получаем данные через новый API
    const result = await executeReport(REPORT_TYPES.TICKET_REPORT_EXPAND, { ticketId: numericTicketId });

    // Сортировка данных по row_id
    const myData = result.dataObjects.sort((a, b) => a.row_id - b.row_id);

    // Возвращаем данные вместе с флагом успеха
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.log('myData:', myData);
    }
    return { success: true, data: myData, message: 'История талона успешно загружена' };
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.error('Ошибка при получении истории талона:', error);
    }
    return { success: false, data: [], message: 'Не удалось загрузить историю талона' };
  }
};

// Функция для восстановления талона
export const restoreTicket = async (ticketId, setLoading, data, setData, setFilteredData) => {
  try {
    setLoading(true);
    // Получаем токен из localStorage
    const token = localStorage.getItem('token');

    if (!token) {
      throw new Error('Токен авторизации не найден');
    }

    // Преобразуем ticketId в число, если он был строкой
    const numericTicketId = parseInt(ticketId, 10);

    // Импортируем axios только при вызове функции
    // eslint-disable-next-line global-require
    const axios = require('axios').default;

    // Делаем запрос к API для восстановления талона
    const response = await axios.post(`/server/api/changeclosedticketstatus/?action=return&token=${token}`, {
      ticket_id: [numericTicketId],
    });

    // Проверяем успешность запроса
    if (response.data && response.data.status === 'ok') {
      // Обновляем список талонов
      const updatedData = data.filter((item) => item.ticket_id !== numericTicketId);
      setData(updatedData);
      setFilteredData(updatedData);
      return { success: true, message: `Талон с ID ${ticketId} успешно восстановлен` };
    }
    return { success: false, message: response.data.message || 'Ошибка при восстановлении талона' };
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.error('Ошибка при восстановлении талона:', error);
    }
    throw error;
  } finally {
    setLoading(false);
  }
};
